<content>
  <section id="big-modal">
    <form [formGroup]="newForm" [ngClass]="{'show-error':showError}">
      <div class="info">{{'global.infoRequired' | translate}}</div>
      <div class="entry-4-modal calendar">
        <label>{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.form.fecha' | translate}} *</label>
        <input [matDatepicker]="fechaDesignacion" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaDesignacion"
          (click)="fechaDesignacion.open()">
        <mat-datepicker #fechaDesignacion></mat-datepicker>
      </div>
      <div class="entry-4-modal">
          <label>{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.form.denominacion' | translate}}</label>
          <input type="text" formControlName="denominacion">
      </div>
      <div class="entry-4-modal">
          <label>{{ 'global.finca' | translate}}</label>
          <input type="text" formControlName="finca">
      </div>
      <div class="entry-4-modal">
          <label>{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.form.superficie' | translate}}</label>
          <input type="number" formControlName="superficie">
      </div>
      <div class="entry-4-modal">
        <label>{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.form.nPlantas' | translate}}</label>
        <input type="text" formControlName="nPlantas">
      </div>
      <div class="entry-4-modal">
        <label>{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.form.aforoDisponible' | translate}}
          ({{(this.newForm ? this.newForm.get('aforoDisponible')?.value : 0) | number : '1.2-2': defaultLanguage}}
          Kg)</label>
        <progress [ngClass]="{'exceeded': porcentajeAforoDisponible > 100 ||
            porcentajeAforoDisponible < 0}" [value]="porcentajeAforoDisponible" max="100"
            min="-1000"></progress><span>{{porcentajeAforoDisponible.toFixed(2)| number : '1.2-2': defaultLanguage}}%</span>
      </div>
      <div class="entry-4-modal">
        <label>{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.form.kilosDesignar' | translate}} *</label>
        <input type="number" formControlName="cantidad">
      </div>
      <div class="entry-4-modal">
        <label>{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.form.etiquetador' | translate}} *</label>
        <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="newForm.get('etiquetador')" [disabled]="disabledEtiquetadores"
        [placeHolder]="false"></app-filterable-list>
      </div>
      <div class="entry-3-modal">
        <input type="checkbox" id="almacenes" formControlName="almacenes">
        <label for="almacenes">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.form.todosAlmacenes' | translate}}</label>
      </div>
      <div *ngIf="showAlmacenes">
        <content *ngFor="let almacen of almacenes">
            <form>
                <div class="entry-3">
                    <input type="text" readonly value="{{almacen.des}}">
                </div>
                <div class="entry-3">
                    <input type="checkbox" id="{{almacen.id}}" name="checkAlmacenes" (click)="addAlmacenes($event)">
                    <label for="{{almacen.id}}"></label>
                </div>
            </form>
        </content>
      </div>
    </form>
    <footer class="button-bar-right">
      <button (click)="insertar()">{{'global.insertar' | translate}}</button>
    </footer>
    <table>
      <thead>
        <tr>
            <th class="id">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.table.id' | translate}}</th>
            <th class="date">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.table.fecha' | translate}}</th>
            <th class="string">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.table.denominacion' | translate}}</th>
            <th class="string">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.table.etiquetador' | translate}}</th>
            <th class="string">{{ 'global.finca' | translate}}</th>
            <th class="string">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.table.marca' | translate}}</th>
            <th class="string">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.table.productor' | translate}}</th>
            <th class="string">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.table.licencia' | translate}}</th>
            <th class="string">{{ 'global.municipio' | translate}}</th>
            <th class="number">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.table.aforo' | translate}}</th>
            <th class="number">{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.table.designado' | translate}}</th>
            <th class="action"></th>
        </tr>
      </thead>
      <tbody *ngFor="let designacion of designaciones; trackBy: trackByDesignacionId">
        <tr>
          <td class="id">{{designacion.id}}</td>
          <td class="date">{{designacion.fecha | date: 'shortDate' : undefined : defaultLanguage}}</td>
          <td class="string">{{designacion.desDenominacion}}</td>
          <td class="string">{{designacion.desEtiquetador}}</td>
          <td class="string">{{designacion.desFinca}}</td>
          <td class="string">{{designacion.desMarca}}</td>
          <td class="string">{{designacion.desProductor}}</td>
          <td class="string">{{designacion.nLicencia}}</td>
          <td class="string">{{designacion.desMunicipio}}</td>
          <td class="number">{{designacion.aforoCultivo}}</td>
          <td class="number">{{designacion.cantidad}}</td>
          <th class="action">
              <i class="far fa-trash-alt" app-click-stop-propagation (click)="askDelete(designacion)"
              title="{{'titles.eliminar' | translate}}"></i>
          </th>
        </tr>
      </tbody>
      <tfoot *ngIf="!designaciones || (designaciones && designaciones.length < 1)">
        <tr>
            <td colspan="12">
                {{ 'global.noContent' | translate}}
            </td>
        </tr>
      </tfoot>
    </table>
    <footer class="button-bar-right">
      <button (click)="close()">{{'global.cerrar' | translate}}</button>
    </footer>
  </section>
</content>
<div class="modal" *ngIf="capacidadModal">
  <div class="modal-content">
    <header>
      <h4>{{'mantenimientoDesignaciones.capacidad.titulo' | translate}}</h4>
    </header>
    <content>
      <p>{{'mantenimientoDesignaciones.capacidad.descripcion' | translate}}</p>
    </content>
    <footer>
      <button class="secondary" (click)="capacidadModal = false">{{'global.cancelar' | translate}}</button>
      <button (click)="addDesignacion()">{{'global.confirmar' | translate}}</button>
    </footer>
  </div>
</div>
<div class="modal" *ngIf="deleteModal">
  <div class="modal-content">
      <header>
          <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
      </header>
      <content>
          <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
      </content>
      <footer>
          <button class="secondary" (click)="this.deleteModal = false">{{ 'global.cancelar' | translate }}</button>
          <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
      </footer>
  </div>
</div>
<app-toast *ngIf="mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
